export default class CommandeApiDriveService {
  path = "/api/me/newsletters";
  pathAnonymosNewsletter = "/api/formulaires/inscriptionAnonymeNewsletter"
  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Liste des newsletters du client connecté
   */
  async newsletters(params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(this.path, config);
    return res.data.data;
  }

  /**
   * Détail d'une newsletter du client connecté
   * @param {String} magId
   */
  async newsletter(magId) {
    const res = await this.httpApi.get(`${this.path}/${magId}`);
    return res.data;
  }

  /**
   * Création d'une newsletter du client connecté
   * @param {String} magId
   */
  async create(magId) {
    const data = {
      magasin_id: magId
    };
    const res = await this.httpApi.post(`${this.path}`, data);
    return res.data;
  }

  /**
   * Suppression d'une newsletter du client connecté
   * @param {String} id
   */
  async delete(id) {
    const res = await this.httpApi.delete(`${this.path}/${id}`);
    return res.data;
  }

  /**
   * inscription anonyme a la newsletter
   * @param {Object} data
   */
  async anonymusNewsletterSubscription(data) {
    const config = { ...this.httpApi.getConfig(), ...{ tokenClient: true } };
    const res = await this.httpApi.post(`${this.pathAnonymosNewsletter}`, data, config);
    return res.data;
  }
}
